import artikelauswahlClient from "@/legacy/artikelauswahlClient";
import { WarenkorbTyp } from "@/lib/models/warenkorb";
import { getAnzahlWarenkorbPositionen, getWarenkorbOverlayResponse } from "@/lib/warenkorb";

export async function updateWarenkoerbeInfos() {
	let data = await getWarenkorbOverlayResponse();

	$("[data-warenkorb-overlay-replaceable]").replaceWith(data.PartialView);
	artikelauswahlClient.AktualisiereMengenAnzeige(WarenkorbTyp.Warenkorb, data.AnzahlPositionen);
	$(".shopping-cart-overlay__order, .shopping-cart-overlay__delete").toggle(data.AnzahlPositionen > 0);

	artikelauswahlClient.AktualisiereMengenAnzeige(WarenkorbTyp.Warenkorb, await getAnzahlWarenkorbPositionen(WarenkorbTyp.Warenkorb));
	artikelauswahlClient.AktualisiereMengenAnzeige(WarenkorbTyp.Anfragekorb, await getAnzahlWarenkorbPositionen(WarenkorbTyp.Anfragekorb));
}
